"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOlxPayButtons = void 0;
var _reselect = require("reselect");
var _chatSelector = require("./chatSelector");
var _getWalletButtons = function _getWalletButtons(_ref) {
  var walletButtons = _ref.walletButtons;
  return walletButtons;
};
var getOlxPayButtons = exports.getOlxPayButtons = (0, _reselect.createSelector)([_chatSelector.getCurrentChat, _getWalletButtons], function (chat, walletButtons) {
  var sellerId = chat.sellerId,
    buyerId = chat.buyerId,
    listId = chat.listId,
    username = chat.username;
  var key = "".concat(listId, "-").concat(sellerId, "-").concat(buyerId, "-").concat(username);
  return walletButtons[key] || [];
});